import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class Donut extends Component {
    constructor(props) {
        super(props);

        this.state = {
            series:  Object.values(this.props.data),
            options: {
                labels: Object.keys(this.props.data),
                chart: {
                    type: "donut"
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(2) + "%";
                    }
                },
                plotOptions: {
                    pie: {
                      donut: {
                        size: "50%",
                        labels: {
                          show: true,
                          name: {
                            show: true,
                            fontSize: '22%',
                            fontFamily: 'Roboto',
                            color: '#dfsda',
                            offsetY: -10
                          },
                          value: {
                            show: true,
                            fontSize: '100%',
                            fontFamily: 'Roboto',
                            color: undefined,
                            offsetY: 16,
                            formatter: function (val) {
                              return val
                            }
                          },
                          total: {
                            show: true,
                            label: 'Total',
                            color: '#373d3f',
                            fontSize: "100%",
                            formatter: function (w) {
                              return w.globals.seriesTotals.reduce((a, b) => {
                                return a + b
                              }, 0)
                            }
                          }
                        }
                      }
                    }
                  },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: "100%"
                            },
                            legend: {
                                position: "bottom"
                            }
                        }
                    }
                ]
            }
        };
    }
    render() {
        return (
            <div>
                <Chart
                    options={this.state.options}
                    series={this.state.series}
                    labels={this.state.labels}
                    type="donut"
                />
            </div>
        );
    }
}
